import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

export type StayShift = "morning" | "evening";

export interface ShiftPickerProps {
  label: string;
  value: StayShift | null;
  windowLabel?: Record<StayShift, string>;
  onChange: (value: StayShift) => void;
}

/** Chegada ou saída no turno da manhã ou da noite, quando a clínica usa dois. */
export function ShiftPicker({ label, value, windowLabel, onChange }: ShiftPickerProps) {
  const { t } = useTranslation("daycareHotel");
  return (
    <div className="grid gap-1.5">
      <span className="akuna-field__label">{label}</span>
      <div role="radiogroup" aria-label={label} className="flex flex-wrap gap-1.5">
        {(["morning", "evening"] as const).map((shift) => (
          <button
            key={shift}
            type="button"
            role="radio"
            aria-checked={value === shift}
            onClick={() => onChange(shift)}
            className={cn(
              "rounded-full border px-3 py-1.5 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
              value === shift ? "border-primary bg-primary text-primary-foreground" : "border-border bg-background text-foreground hover:bg-muted",
            )}
          >
            {t(shift === "morning" ? "shiftMorning" : "shiftEvening")}
            {windowLabel?.[shift] ? <span className="ms-1 text-xs opacity-80">{windowLabel[shift]}</span> : null}
          </button>
        ))}
      </div>
    </div>
  );
}
